import { progress, velocityPerSecond } from '@motionone/utils';

/**
 * A time in milliseconds, beyond which we consider the scroll velocity to be 0.
 */
var maxElapsed = 50;
var createAxisInfo = function createAxisInfo() {
  return {
    current: 0,
    offset: [],
    progress: 0,
    scrollLength: 0,
    targetOffset: 0,
    targetLength: 0,
    containerLength: 0,
    velocity: 0
  };
};
var createScrollInfo = function createScrollInfo() {
  return {
    time: 0,
    x: createAxisInfo(),
    y: createAxisInfo()
  };
};
var keys = {
  x: {
    length: "Width",
    position: "Left"
  },
  y: {
    length: "Height",
    position: "Top"
  }
};
function updateAxisInfo(element, axisName, info, time) {
  var axis = info[axisName];
  var _keys$axisName = keys[axisName],
    length = _keys$axisName.length,
    position = _keys$axisName.position;
  var prev = axis.current;
  var prevTime = info.time;
  axis.current = element["scroll" + position];
  axis.scrollLength = element["scroll" + length] - element["client" + length];
  axis.offset.length = 0;
  axis.offset[0] = 0;
  axis.offset[1] = axis.scrollLength;
  axis.progress = progress(0, axis.scrollLength, axis.current);
  var elapsed = time - prevTime;
  axis.velocity = elapsed > maxElapsed ? 0 : velocityPerSecond(axis.current - prev, elapsed);
}
function updateScrollInfo(element, info, time) {
  updateAxisInfo(element, "x", info, time);
  updateAxisInfo(element, "y", info, time);
  info.time = time;
}
export { createScrollInfo, updateScrollInfo };